import clsx from 'clsx'
import { useId } from 'react'

type CsvUploadProps = {
  id?: string
  label?: string
  accept?: string
  multiple?: boolean
  file?: File | null
  disabled?: boolean
  onChange: (file: File) => void
}

export function InputFile({
  id,
  label,
  accept,
  multiple = false,
  file,
  disabled = false,
  onChange,
}: CsvUploadProps) {
  const generatedId = useId()
  const inputId = id ?? generatedId
  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.files?.[0]
    if (!v) {
      return
    }
    onChange(v)
  }

  return (
    <label
      htmlFor={inputId}
      aria-disabled={disabled}
      className={clsx({
        'pointer-events-none': disabled,
        'cursor-pointer': !disabled,
      })}
    >
      {label && <span className="text-sm leading-[21px]">{label}</span>}
      <div
        className={clsx(
          'text-sm leading-[21px] border border-gray-300 rounded-lg p-2.5',
          {
            'text-gray-400': !file,
            'border-gray-500 text-gray-600': file,
          },
        )}
      >
        {file?.name || 'ファイルを選択してください'}
      </div>
      <input
        id={inputId}
        type="file"
        accept={accept}
        multiple={multiple}
        onChange={handleFileSelect}
        disabled={disabled}
        hidden
      />
    </label>
  )
}
